<template>
  <div class="service-detail">
    <div class="label">ผู้ให้บริการ</div>
    <provider-selector
      class="provider mt-2"
      :value="provider"
      :isShowProviderVat="true"
      :notClearAble="true"
      @input="handleSelectProvider"
    ></provider-selector>
    <hr />
    <div class="title">รายละเอียดบริการ</div>
    <div class="label mt-2">ชื่อบริการ :</div>
    <div class="text">{{ name }}</div>
    <div class="label mt-1">รายละเอียด (อย่างย่อ) :</div>
    <div class="text">{{ shortDescription }}</div>
    <div class="label mt-1" v-if="qualityUnitText">ประเภท :</div>
    <div class="text" v-if="qualityUnitText">{{ qualityUnitText }}</div>
    <div class="label mt-1" v-if="mainOption">Option หลัก</div>
    <div class="text">{{ mainOption }}</div>
    <div class="label mt-1" v-if="extraOption">Option เสริม</div>
    <div class="text">{{ extraOption }}</div>
    <div class="label mt-1">รายละเอียด :</div>
    <div class="text">{{ description }}</div>
    <div class="label mt-1">เงื่อนไขการให้บริการ :</div>
    <div class="text">{{ termsAndConditions }}</div>
  </div>
</template>

<script>
import ProviderSelector from "@/lib/components/ProviderSelector";
export default {
  components: {
    ProviderSelector
  },
  props: [
    "name",
    "shortDescription",
    "description",
    "termsAndConditions",
    "provider",
    "mainOption",
    "extraOption",
    "qualityUnitText"
  ],
  methods: {
    handleSelectProvider(provider) {
      if (confirm(`เปลี่ยนผู้ให้บริการเป็น ${provider.name}`)) {
        this.$emit("newProvider", provider);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-weight: bold;
}

.label {
  color: #808080;
  font-size: 0.9rem;
}

.title,
.text {
  color: black;
  font-size: 1rem;
}

.title,
.text + .label {
  margin-top: 16px;
}

.provider {
  width: 450px;
}
</style>



// WEBPACK FOOTER //
// src/features/subscriptions/modules/appointments/components/ServiceDetail.vue